// Central design tokens for the Nexus "minimal / flat" design system.
// One accent color, neutral grays, hairline borders, generous whitespace, no gradients/blur.
// Import these anywhere instead of hard-coding hex values so the look stays consistent.

export const tokens = {
  color: {
    // Single accent
    accent: '#2563EB',
    accentHover: '#1D4ED8',
    accentSoft: '#EFF4FF', // tinted background for selected/active states
    accentBorder: '#BFD3FF',

    // Surfaces
    bg: '#F7F8FA', // app background
    surface: '#FFFFFF', // cards, panels
    surfaceMuted: '#FAFBFC', // table heads, subtle fills

    // Hairlines / borders
    border: '#E7E9EE',
    borderStrong: '#D7DAE0',

    // Text
    text: '#0F1115',
    textSecondary: '#5C6470',
    textMuted: '#8A909C',

    // Semantic (status / finance). Used sparingly.
    success: '#16A34A',
    successSoft: '#E9F7EF',
    danger: '#DC2626',
    dangerSoft: '#FCECEC',
    warning: '#D97706',
    warningSoft: '#FDF3E7',
    info: '#2563EB',
    infoSoft: '#EFF4FF',
    neutral: '#5C6470',
    neutralSoft: '#F1F3F6',
  },

  radius: {
    sm: 6,
    md: 8,
    lg: 12,
    pill: 999,
  },

  // The only elevation in the system — reserved for floating layers (menus, popovers, dialogs).
  shadow: {
    pop: '0 6px 24px rgba(15, 17, 21, 0.10), 0 1px 2px rgba(15, 17, 21, 0.06)',
    none: 'none',
  },

  font: {
    family:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
} as const;

// Categorical palette for charts — distinct but muted, anchored on the accent.
export const CHART_PALETTE = [
  '#2563EB', // accent blue
  '#0EA5E9', // sky
  '#14B8A6', // teal
  '#8B5CF6', // violet
  '#F59E0B', // amber
  '#EC4899', // pink
  '#10B981', // emerald
  '#64748B', // slate
];

export const chartColor = (i: number) => CHART_PALETTE[i % CHART_PALETTE.length];
